export const OMENS_WHATSAPP_NUMBER = '11989533236'
export const OMENS_WHATSAPP_NUMBER_MASKED = '(11) 98953-3236'
export const OMENS_WHATSAPP_LINK = `https://wa.me/55${OMENS_WHATSAPP_NUMBER}`
export const OMENS_SUPPORT_EMAIL = 'contato@omens.com.br'

export const MEDLEVE_WHATSAPP_NUMBER = '11993032210'
export const MEDLEVE_WHATSAPP_NUMBER_MASKED = '(11) 99303-2210'
export const MEDLEVE_WHATSAPP_LINK = `https://wa.me/55${MEDLEVE_WHATSAPP_NUMBER}`
export const MEDLEVE_SUPPORT_EMAIL = 'contato@medleve.com'
